
        <template>
          <div class="vc-snippet-doc">
            <h1>ECMAScript 6 简介</h1>
<p>目前，各大浏览器对 ES6 的支持可以查看<a href="https://kangax.github.io/compat-table/es6/">kangax.github.io/compat-table/es6/</a>。</p>
<p><code>Node.js</code> 是 <code>JavaScript</code> 的服务器运行环境（<code>runtime</code>）。它对 <code>ES6</code> 的支持度更高。除了那些默认打开的功能，还有一些语法功能已经实现了，但是默认没有打开。使用下面的命令，可以查看 <code>Node.js</code> 默认没有打开的 <code>ES6</code> 实验性语法。</p>
<pre class="hljs"><code><span class="hljs-comment">// Linux &amp; Mac</span>
$ node --v8-options | grep harmony

<span class="hljs-comment">// Windows</span>
$ node --v8-options | findstr harmony
</code></pre>
<h2>Babel 转码器</h2>
<p><code>Babel</code> 是一个广泛使用的 <code>ES6</code> 转码器，可以将 <code>ES6</code> 代码转为 <code>ES5</code> 代码，从而在老版本的浏览器执行。这意味着，你可以用 <code>ES6</code> 的方式编写程序，又不用担心现有环境是否支持。下面是一个例子。</p>
<pre class="hljs"><code><span class="hljs-comment">// 转码前</span>
input.<span class="hljs-title function_">map</span>(<span class="hljs-function"><span class="hljs-params">item</span> =&gt;</span> item + <span class="hljs-number">1</span>);

<span class="hljs-comment">// 转码后</span>
input.<span class="hljs-title function_">map</span>(<span class="hljs-keyword">function</span> (<span class="hljs-params">item</span>) {
  <span class="hljs-keyword">return</span> item + <span class="hljs-number">1</span>;
});
</code></pre>
<p>上面的原始代码用了箭头函数，<code>Babel</code> 将其转为普通函数，就能在不支持箭头函数的 <code>JavaScript</code> 环境执行了。</p>
<p>下面的命令在项目目录中，安装 <code>Babel。</code></p>
<pre class="hljs"><code>$ npm install --save-dev @babel/core
</code></pre>
<h2>配置文件<code>.babelrc</code></h2>
<p><code>Babel</code> 的配置文件是<code>.babelrc</code>，存放在项目的根目录下。使用 <code>Babel</code> 的第一步，就是配置这个文件。</p>
<p>该文件用来设置转码规则和插件，基本格式如下。</p>
<pre class="hljs"><code>{
  <span class="hljs-string">&quot;presets&quot;</span>: [],
  <span class="hljs-string">&quot;plugins&quot;</span>: []
}
</code></pre>
<p><code>presets</code>字段设定转码规则，官方提供以下的规则集，你可以根据需要安装。</p>
<h2>最新转码规则</h2>
<pre class="hljs"><code>$ npm install --save-dev @babel/preset-env

# react 转码规则
$ npm install --save-dev @babel/preset-react
</code></pre>
<p>然后，将这些规则加入<code>.babelrc。</code></p>
<pre class="hljs"><code>  {
    <span class="hljs-string">&quot;presets&quot;</span>: [
      <span class="hljs-string">&quot;@babel/env&quot;</span>,
      <span class="hljs-string">&quot;@babel/preset-react&quot;</span>
    ],
    <span class="hljs-string">&quot;plugins&quot;</span>: []
  }
</code></pre>
<p>注意，以下所有 <code>Babel</code> 工具和模块的使用，都必须先写好<code>.babelrc。</code></p>
<h2>命令行转码</h2>
<p><code>Babel</code> 提供命令行工具<code>@babel/cli</code>，用于命令行转码。</p>
<p>它的安装命令如下。</p>
<pre class="hljs"><code>$ npm install --save-dev @babel/cli
</code></pre>
<p>基本用法如下。</p>
<pre class="hljs"><code># 转码结果输出到标准输出
$ npx babel example.<span class="hljs-property">js</span>

# 转码结果写入一个文件
# --out-file 或 -o 参数指定输出文件
$ npx babel example.<span class="hljs-property">js</span> --out-file compiled.<span class="hljs-property">js</span>
# 或者
$ npx babel example.<span class="hljs-property">js</span> -o compiled.<span class="hljs-property">js</span>

# 整个目录转码
# --out-dir 或 -d 参数指定输出目录
$ npx babel src --out-dir lib
# 或者
$ npx babel src -d lib

# -s 参数生成source map文件
$ npx babel src -d lib -s
</code></pre>

          </div>
        </template>
        <script>
           
           export default {
           name: 'vc-component-doc',
           components: {
            
           },
           data(){
            return {}
           }
         }
       </script>
       <style lang='scss'>
         
       </style>